function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.46,0A12.46,12.46,0,1,0,24.91,12.46,12.46,12.46,0,0,0,12.46,0Zm0,24.16a11.71,11.71,0,1,1,11.7-11.7A11.72,11.72,0,0,1,12.46,24.16Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8,10.55h8.27a1.9,1.9,0,0,0,1.87-2A2.08,2.08,0,0,0,16,6.52H12.22a1,1,0,0,1-1-1v-1H9.43V6.31a2,2,0,0,0,2,2h4.73a.25.25,0,1,1,0,.49L8.2,8.68H8.1a2,2,0,0,0,0,4l8,.09a.27.27,0,0,1,0,.54H8a2,2,0,0,0,0,4H16.1a.25.25,0,1,1,0,.49H13.71a2,2,0,0,0-2,2v1.3h1.75v-.52a1,1,0,0,1,1-1h1.6a2,2,0,0,0,2-2,2,2,0,0,0-2-2H8a.24.24,0,0,1-.24-.25A.24.24,0,0,1,8,15h8.15a2,2,0,0,0,0-4H8a.24.24,0,0,1-.24-.25A.24.24,0,0,1,8,10.55Z"
});

function SvgFodmap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 20,
    fill: "currentColor",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.91 24.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFodmap);
export default __webpack_public_path__ + "static/media/FODMAP.2c7d7fb0.svg";
export { ForwardRef as ReactComponent };